import React from 'react';
import { BackButton } from 'components/buttons';
import Header, { ButtonConfig } from 'components/header/Header';
import { Dataset } from 'types/Dataset';
import { NIcon, NSpinner } from '@innersource-nn/novoui-react';
import { useModal } from 'hooks/useModal';

interface FailedInProgressDatasetProps {
    dataset: Dataset;
    status: string;
}

export default function FailedInProgressDataset({
    dataset,
    status,
}: FailedInProgressDatasetProps) {
    const { openDeleteDataset } = useModal();

    const buttonConfigs: ButtonConfig[] = [
        {
            label: 'Remove',
            onClick: () =>
                openDeleteDataset({
                    label: dataset.label,
                    datasetUri: dataset.datasetUri,
                    terminationProtection: dataset.stack.terminationProtection,
                }),
            red: true,
            icon: 'trash',
        },
    ];

    return (
        <div>
            <Header
                title={dataset.label}
                buttonConfigs={
                    status.includes('IN_PROGRESS') ? undefined : buttonConfigs
                }
                backButton
            />
            <div className="empty-place-holder mt-12 ">
                <div className="flex flex-col items-center text-true-blue">
                    <div className="round-div-icon-middle">
                        {status.includes('IN_PROGRESS') || status === '' ? (
                            <NSpinner color="blue" size="large" />
                        ) : (
                            <div className="bg-lava-red-200 round-div-icon-middle h-[5rem]	w-[5rem]">
                                <NIcon
                                    iconName="alert"
                                    size={40}
                                    className="fill-true-blue"
                                />
                            </div>
                        )}
                    </div>
                    <b className="text-2xl mt-16">
                        {status.includes('IN_PROGRESS') || status === ''
                            ? 'Dataset creation in progress...'
                            : 'Dataset creation failed'}
                    </b>
                    <p className="text-true-blue w-1/2 text-center mt-8">
                        {status.includes('IN_PROGRESS') || status === ''
                            ? 'We are now creating your new dataset, please check back in a bit. The creation can take up to 3 - 8 minutes'
                            : 'We encountered an error while creating your dataset. Please delete this dataset and try creating the data set again with a different environment'}
                    </p>
                </div>
            </div>
        </div>
    );
}
